import useJwt from '@core/auth/jwt/useJwt'
import axios from '@axios'

axios.defaults.withCredentials = true
const { jwt } = useJwt(axios, {})
export default jwt
